import { render, staticRenderFns } from "./teamPrice.vue?vue&type=template&id=289f6afe&scoped=true"
import script from "./teamPrice.vue?vue&type=script&lang=js"
export * from "./teamPrice.vue?vue&type=script&lang=js"
import style0 from "./teamPrice.vue?vue&type=style&index=0&id=289f6afe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289f6afe",
  null
  
)

export default component.exports